export default __webpack_public_path__ + "static/Tempoist2.inline-d7639c8a65a7d073cc46c5c4bc05777b.png";